
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/katalog-firm/[slug]/kontakt",
      function () {
        return require("private-next-pages/katalog-firm/[slug]/kontakt.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/katalog-firm/[slug]/kontakt"])
      });
    }
  